import * as React from 'react';

import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from './components/ui/card.js';
import { cn } from './lib/utils.js';

type DimeCardProps = Readonly<React.ComponentProps<typeof Card> & { borderless?: boolean }>;

export function DimeCard({ borderless, className, ...props }: DimeCardProps) {
  return (
    <Card
      className={cn(borderless && 'overflow-visible ring-0 shadow-none rounded-none', className)}
      {...props}
    />
  );
}

export function DimeCardHeader({
  className,
  ...props
}: Readonly<React.ComponentProps<typeof CardHeader>>) {
  return (
    <CardHeader
      // Stack the action below the title/description on small viewports; switch to the
      // shadcn `[1fr_auto]` two-column layout at the `sm` breakpoint and up.
      className={cn(
        'has-data-[slot=card-action]:grid-cols-1 sm:has-data-[slot=card-action]:grid-cols-[1fr_auto]',
        className,
      )}
      {...props}
    />
  );
}

export function DimeCardTitle({ ...props }: Readonly<React.ComponentProps<typeof CardTitle>>) {
  return <CardTitle {...props} />;
}

export function DimeCardDescription({
  ...props
}: Readonly<React.ComponentProps<typeof CardDescription>>) {
  return <CardDescription {...props} />;
}

export function DimeCardContent({ ...props }: Readonly<React.ComponentProps<typeof CardContent>>) {
  return <CardContent {...props} />;
}

export function DimeCardFooter({ ...props }: Readonly<React.ComponentProps<typeof CardFooter>>) {
  return <CardFooter {...props} />;
}

export function DimeCardAction({
  className,
  ...props
}: Readonly<React.ComponentProps<typeof CardAction>>) {
  return (
    <CardAction
      // Small viewports: sit in column 1, auto-placed below the title/description, left-aligned.
      // sm+: restore shadcn's top-right placement in the second column.
      className={cn(
        'col-start-1 row-start-auto justify-self-start sm:col-start-2 sm:row-start-1 sm:justify-self-end',
        className,
      )}
      {...props}
    />
  );
}
